module.exports = __webpack_public_path__ + "media/flags/pt-b68938af.gif";